import { render } from "./BookingCsvImport.vue?vue&type=template&id=20106f4a"
import script from "./BookingCsvImport.vue?vue&type=script&lang=js"
export * from "./BookingCsvImport.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2878166519/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__